import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

interface EmailStepProps {
	email: string;
	onEmailChange: (email: string) => void;
	onSubmit: (e: React.FormEvent) => void;
}

/**
 * This component is used to enter the email for the login process.
 * It is used in the LoginPage component.
 * @param email - The email of the user.
 */
export const EmailStep = ({
	email,
	onEmailChange,
	onSubmit,
}: EmailStepProps) => {
	return (
		<form onSubmit={onSubmit} className="space-y-6">
			<h1 className="text-center text-2xl font-semibold text-foreground">
				Taxpeer Korrektur Plattform
			</h1>

			<div className="space-y-2">
				<label className="text-sm text-muted-foreground" htmlFor="email">
					Email-Adresse
				</label>
				<Input
					id="email"
					type="email"
					value={email}
					onChange={(e) => onEmailChange(e.target.value)}
					placeholder="Email-Adresse"
					className="w-full"
				/>
			</div>

			<Button type="submit" className="w-full" size="lg">
				Weiter
			</Button>
		</form>
	);
};
